import { CountryOptions, ValidCountry } from './types'

export const countryMapping: { [key: string]: string } = {
  AU: 'Australia',
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  BR: 'Brazil',
  CA: 'Canada',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DE: 'Germany',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'France',
  GR: 'Greece',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IN: 'India',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JP: 'Japan',
  LV: 'Latvia',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MY: 'Malaysia',
  MT: 'Malta',
  MX: 'Mexico',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  NO: 'Norway',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  RU: 'Russia',
  SE: 'Sweden',
  SG: 'Singapore',
  SI: 'Slovenia',
  SK: 'Slovakia',
  ES: 'Spain',
  CH: 'Switzerland',
  GB: 'United Kingdom',
  US: 'United States',
  ZA: 'South Africa',
}
export const getCountryOptions = (): CountryOptions => {
  return (Object.keys(countryMapping) as Array<ValidCountry>).map((code) => {
    return { code, label: countryMapping[code] }
  })
}

export const getCountryName = (code: string) => {
  if (code in countryMapping) {
    return countryMapping[code as ValidCountry]
  }
  return null
}
